/**
 * Configuration for data storage limits in UIBlocks
 */
export const STORAGE_CONFIG = {
  /**
   * Maximum number of rows to store in UIBlock data
   */
  MAX_ROWS_PER_BLOCK: 10,

  /**
   * Maximum size in bytes per UIBlock (500KB - reduced to save memory)
   */
  MAX_SIZE_PER_BLOCK_BYTES: 500 * 1024, // 500KB

  /**
   * Number of days to keep threads before cleanup
   * Note: This is for in-memory storage. Conversations are also persisted to database.
   */
  THREAD_RETENTION_DAYS: 2, // Reduced from 7 to 1 day for memory efficiency

  /**
   * Number of days to keep UIBlocks before cleanup
   * Note: This is for in-memory storage. Data is also persisted to database.
   */
  UIBLOCK_RETENTION_DAYS: 2, // Reduced from 7 to 1 day for memory efficiency
};
